export default "__VITE_ASSET__1nKMmCboA9w846d_4i7g3A__"